<template>
	<div id="skyCascaderPanels">
		<div class="search">
			<el-select popper-class="searchSelect" v-model="searchValue" multiple filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="搜索国家/地区">
				<el-option
					v-for="(item, index) in searchList"
					:key="item[attrs.value] + index"
					:label="item[attrs.label]"
					:value="item[attrs.value]"
					:disabled="item.disabled">
					<span class="searchSelectLeft" :style="{color:isHave(item[attrs.value], checked)?'#3DA1FF':'#606266'}">{{ item[attrs.label] }}</span>
					<!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item[attrs.value] }}</span> -->

					<span class="searchSelectRight cursor" @click="exclude(item, item, 'exclude', $event)" v-show="isHave(item[attrs.value], rightChecked) || !isHave(item[attrs.value], excludeChecked)"> 排除 </span>
					<span class="searchSelectRight disab" v-show="isHave(item[attrs.value], excludeChecked)"> 已排除 </span>
					<span class="searchSelectRight margin_r_8 cursor" @click="position(item, item, 'position', $event)" v-show="isHave(item[attrs.value], excludeChecked) || !isHave(item[attrs.value], rightChecked)"> 定位 </span>
					<span class="searchSelectRight disab margin_r_8" v-show="isHave(item[attrs.value], rightChecked)"> 已定位 </span>
				</el-option>
			</el-select>
			<span class="batch" @click="batchOperation">批量操作</span>
		</div>
		<skySelectCard :header="label">
			<el-cascader-panel
				v-model="checked"
				ref="regional"
				:options="list"
				@change="select"
				@click.native="editName"
				class="card"
				:props="attrs"
				id="hidden_checkbox"
			>
        <template slot-scope="{ node, data }">
          <div class="operation">
						<span class="info" v-if="!node.isLeaf" :title="data[attrs.label]"> {{ data[attrs.label] }}({{ data[attrs.num] }}) </span>
            <span class="info" v-if="node.isLeaf" :title="data[attrs.label]">{{ data[attrs.label] }}</span>
            <p class="posi">
							<!-- <span class="margin_r_8 all_select" v-show="!node.isLeaf && node.checked"> 已全选 </span> -->
              <span class="margin_r_8" @click="position(node, data, 'position', $event)" v-show="(node.isLeaf && !node.checked) || isHave(data[attrs.value], excludeChecked) || data.allData"> 定位 </span>
              <span class="margin_r_8 disab" v-show="isHave(data[attrs.value], rightChecked)"> 已定位 </span>
              <span @click="exclude(node, data, 'exclude', $event)" v-show="(node.isLeaf && !node.checked) || isHave(data[attrs.value], rightChecked) || data.allData"> 排除 </span>
              <span class="disab" v-show="isHave(data[attrs.value], excludeChecked)"> 已排除 </span>
            </p>
          </div>
        </template>
			</el-cascader-panel>
		</skySelectCard>
    
		<div class="sky_select_card_box">
      <skySelectCard>
        <template slot="header">
          <span>已定位({{ rightChecked.length }})</span>
          <el-link
            @click="clear('position')"
            type="primary"
            :underline="false"
            :disabled="rightChecked.length == 0"
            >清空</el-link
          >
        </template>
        <el-scrollbar>
          <skyAlert
            v-for="item in rightChecked"
            :title="getLabel(item)"
            :key="item"
            @close="deleteItem(item)"
          ></skyAlert>
        </el-scrollbar>
      </skySelectCard>
      <skySelectCard>
        <template slot="header">
          <span>已排除({{ excludeChecked.length }})</span>
          <el-link
            @click="clear('exclude')"
            type="primary"
            :underline="false"
            :disabled="excludeChecked.length == 0"
            >清空</el-link
          >
        </template>
        <el-scrollbar>
          <skyAlert
            v-for="item in excludeChecked"
            :title="getLabel(item)"
            :key="item"
            @close="deleteExcludeItem(item)"
          ></skyAlert>
        </el-scrollbar>
      </skySelectCard>
    </div>
		<el-dialog title="批量操作" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
			<el-form :model="form">
				<el-form-item label="">
					<el-input type="textarea" :rows="6" v-model="form.batchValue" autocomplete="off" placeholder="批量输入国家/地区名称，每行一个"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="startMatching">开始匹配</el-button>
			</div>
		</el-dialog>
		<el-dialog title="批量操作" :visible.sync="dialogTabVisible" :close-on-click-modal="false">
			<el-tabs v-model="activeName">
				<el-tab-pane v-for="(item, index) in tabs" :label="item.name + ' (' + item.length + ')'" :name="index + ''" :key="index">
					<div class="tabTit">
						<span>{{ item.msg }}</span>
						<span class="copy" @click="copy">复制</span>
					</div>
					<el-input ref="copy" type="textarea" :rows="6" v-model="item.value" autocomplete="off" placeholder=""></el-input>
				</el-tab-pane>
			</el-tabs>
			<el-radio-group v-model="radio">
				<el-radio :label="1">定位</el-radio>
				<el-radio :label="2">排除</el-radio>
			</el-radio-group>
			<div slot="footer" class="dialog-footer">
				<el-button @click="goBack">返 回</el-button>
				<el-button type="primary" @click="handleClick">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import googleads from '@/backend/services/googleAds/googleAds.js';
import {removeTreeEmpty, editTreeAttr, treeToArray, getCollectionCheckedNodesNoAll, getLastChildrenIdsByParentId, isHave} from '@/utils/index.js';
import skySelectCard from './skySelectCard';
import skyAlert from '../sky-alert.vue';
export default {
	name: 'skyCascaderPanels',
	components: {
		skySelectCard,
		skyAlert
	},
	props: {
		title: {
			type: String
		},
		label: {
			type: String
		},
		value: {
			type: Object,
			default: function() {
				return {};
			}
		},
		options: {
			type: Array,
			default: function() {
				return [];
			}
		},
		attrs: {
			type: Object,
			default: function() {
				return {};
			}
		},
		code: {
			type: String,
			default: ''
		}
	},
	watch: {
		options: {
			handler(val) {
				this.allList = this.treeToArrayLast(val, this.attrs.children).filter(v => v.name != '全部');
				let data = editTreeAttr(val, this.attrs.children, 'resourceName', ['geoTargetConstants/', 'id']);
				// aaa把一级数组子集拍平
				data.forEach((i,index) => {
					if(i[this.attrs.children] && !i[this.attrs.children][0].allData) {
						// 获取树状数组最后一级拍平
						let res = this.treeToArrayLast(i[this.attrs.children], this.attrs.children);
						i[this.attrs.children] = [
							{
								name: '全部', // 增加全部选项
								allData: res.map(item => item.resourceName),
								resourceName: 'helloWorld666' + index,
							},...res];
					}
				});
				this.list = data;
			},
			immediate: true,
			deep: true
		},
		value: {
			handler(val) {
				if (val) {
					if(this.cascaderIds.length) {
						// 防止选中后跳到其他层级选框
						this.checked = this.cascaderIds;
					}else {
						this.checked = [...val.locations, ...val.exceptLocations];
					}
					this.rightChecked = val.locations;
          this.excludeChecked = val.exceptLocations;
					this.sanctionsList.forEach(item => {
						if(this.rightChecked.includes(item)) {
							let id = this.rightChecked.findIndex(key => key == item);
							this.rightChecked.splice(id, 1);
						}
						if(!this.excludeChecked.includes(item)) {
							this.excludeChecked.unshift(item);
						}
						if(!this.checked.includes(item)) {
							this.checked.unshift(item);
						}
					})
				}
			},
			immediate: true,
			// deep: true
		},
		code: {
			handler(val) {
				if (val) {
					this.getCode(val);
				}
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		return {
			list: [],
			checked: [],
			rightChecked: [],
      excludeChecked: [],
			cascaderIds: [],
			allList: [], // 所有数据平铺
			searchList: [],
			searchValue: '',
			dialogFormVisible: false,
			dialogTabVisible: false,
			form: {
				batchValue: '',
			},
			activeName: '0',
			tabs: [
				{
					name: '符合条件',
					msg: '以下是符合条件的国家/地区',
					value: '',
					length: 0,
				}, 
				{
					name: '未匹配到',
					msg: '未匹配到以下国家/地区，可能是拼写错误，请检查',
					value: '',
					length: 0,
				}
			],
			batchList: [],
			radio: 1,
			sanctionsList: ['geoTargetConstants/2643','geoTargetConstants/2736','geoTargetConstants/2906'], // 制裁国家列表 [俄罗斯、苏丹、叙利亚、伊朗、朝鲜、克里米亚、古巴]，固定排除且不可删除
			sanctionsListKey: ['俄罗斯','苏丹','叙利亚','伊朗','朝鲜','克里米亚','古巴'],
			timeout: null,
		};
	},

	mounted() {
		let doc = document.querySelector('#hidden_checkbox');
		doc.onclick = function(e) {
			// 禁止级联复选框点击选中
			e.preventDefault();
			e.stopPropagation();
		};
		this.editName(); // 初次进入替换已选中类名，防止组件选中时滚动条跳转到第一个选中值
	},
	
	methods: {
    isHave,
		// 将树形数据最后一级提取平铺
		treeToArrayLast(tree, child) {
			let arr = [];
			const expanded = datas => {
				if (datas && datas.length > 0) {
					datas.forEach(e => {
						if(!e[child]) {
							arr.push(e);
						}
						expanded(e[child]);
					});
				}
			};
			expanded(tree);
			return arr;
		},
		async getCode(code) {
			let res = await googleads.codeFun(code);
			let data = removeTreeEmpty(res.data, this.attrs.children);
			data = editTreeAttr(data, this.attrs.children, 'resourceName', ['geoTargetConstants/', 'id']);
			this.list = data;
		},
		getLabel(id) {
			let res = treeToArray(this.list, this.attrs.children);
			let data = res.filter(item => item[this.attrs.value] == id);
			return data.length ? data[0][this.attrs.label] : '';
		},
		select() {
			let res = this.$refs.regional.getCheckedNodes();
			this.rightChecked = getCollectionCheckedNodesNoAll(res)
				.map(item => item.value);
			this.change();
		},
		clear(msg) {
      if(msg == 'position') {
				this.checked = this.checked.filter(item => {
					return this.rightChecked.indexOf(item) == -1;
				})
        this.rightChecked = [];
      }else if(msg == 'exclude') {
				this.checked = this.checked.filter(item => {
					if(isHave(item, this.sanctionsList)) {
						// 清空时保留制裁国家排除数据
						return item
					}else {
						return this.excludeChecked.indexOf(item) == -1;
					}
				})
				this.excludeChecked = [...this.sanctionsList]; // 清空时保留制裁国家排除数据
      }
			this.change();
		},
		deleteItem(id) {
			this.rightChecked = this.rightChecked.filter(item => item !== id);
			let isBeing = this.checked.some(item => item == id);
			if (isBeing) {
				// 判断点击删除时右边选中的列表有无当前id，有则过滤当前id
				this.checked = this.checked.filter(item => item !== id);
			} else {
				// 无则根据当前id查询其下所有子集id再与右边选中列表对比过滤相同id
				let ids = getLastChildrenIdsByParentId(this.$refs.regional, id);
				this.checked = this.checked.filter(item => !this.isHave(item, ids));
			}
			this.change();
		},
		change() {
			this.cascaderIds = this.checked;
			let val = {
				locations: this.rightChecked,
        exceptLocations: this.excludeChecked,
			};
			this.$emit('input', val);
			this.$emit('change', val);
		},
		// 删除排除项
		deleteExcludeItem(id) {
			if(isHave(id, this.sanctionsList)) {
				// 制裁国家地区固定排除且不可移除
				this.$message.info('Google 必须遵守美国财政部外国资产控制办公室 (OFAC) 实施的制裁。因此，部分国家或地区的广告客户无法使用 Google Ads，俄罗斯、苏丹、伊朗、叙利亚、朝鲜、克里米亚、古巴!');
				return false;
			}
			this.excludeChecked = this.excludeChecked.filter(item => item !== id);
			let isBeing = this.checked.some(item => item == id);
			if (isBeing) {
				// 判断点击删除时右边选中的列表有无当前id，有则过滤当前id
				this.checked = this.checked.filter(item => item !== id);
			} else {
				// 无则根据当前id查询其下所有子集id再与右边选中列表对比过滤相同id
				let ids = getLastChildrenIdsByParentId(this.$refs.regional, id);
				this.checked = this.checked.filter(item => !this.isHave(item, ids));
			}
			this.change();
		},
    // 排除
    exclude(node, data, msg, e) {
			if(msg && data.allData) {
				// 排除不是最后一级选项时调用
				this.allSelect(data, msg);
				return false;
			}
			if(msg == 'exclude' && this.rightChecked.indexOf(data[this.attrs.value]) != -1) {
				// 定位 已经选了，再点击 排除 时，过滤当前定位选项，添加当前排除选项
				this.rightChecked.splice(this.rightChecked.indexOf(data[this.attrs.value]), 1);
				this.excludeChecked.push(data[this.attrs.value]);
				return false;
			}
      let list = [];
			this.checked = [...[data[this.attrs.value]],...this.checked];
			
      this.$nextTick(() => {
				list = this.checked.filter(item => {
					// 过滤排除选项和全部选项
					return this.rightChecked.indexOf(item) == -1 && item.indexOf('helloWorld666') == -1;
				})
				
				this.excludeChecked = Array.from(new Set([ ...list, ...this.excludeChecked]));

				this.change();

				if(e && e.srcElement.parentNode.className == 'posi') {
					e.srcElement.parentNode.parentNode.parentNode.parentNode.className = 'el-cascader-node is-active';
				}
				this.editName();
      })
    },
    // 定位
    position(node, data, msg, e) {
			if(msg && data.allData) {
				// 定位是全部时
				this.allSelect(data, msg);
				return false;
			}
			if(isHave(data[this.attrs.value], this.sanctionsList)) {
				// 制裁国家地区固定排除且不可移除
				this.$message.info('Google 必须遵守美国财政部外国资产控制办公室 (OFAC) 实施的制裁。因此，部分国家或地区的广告客户无法使用 Google Ads，俄罗斯、苏丹、伊朗、叙利亚、朝鲜、克里米亚、古巴!');
				return false;
			}

			if(msg == 'position' && this.excludeChecked.indexOf(data[this.attrs.value]) != -1) {
				// 排除 已经选了，再点击 定位 时，过滤当前排除选项，添加当前定位选项
				this.excludeChecked.splice(this.excludeChecked.indexOf(data[this.attrs.value]), 1);
				this.rightChecked.push(data[this.attrs.value]);
				return false;
			}
      let list = [];
			this.checked = [...[data[this.attrs.value]],...this.checked];

      this.$nextTick(() => {
				list = this.checked.filter(item => {
					// 过滤排除选项和全部选项
					return this.excludeChecked.indexOf(item) == -1 && item.indexOf('helloWorld666') == -1;
				})

				this.rightChecked = Array.from(new Set([ ...list, ...this.rightChecked]));

				this.change();
				if(e && e.srcElement.parentNode.className == 'posi') {
					// 选中当前值赋予其组件默认选中的类名，防止组件找不到此类名滚动条跳转到顶部
					e.srcElement.parentNode.parentNode.parentNode.parentNode.className = 'el-cascader-node is-active';
				}
				this.editName(); // 修改类目名，防止组件默认跳转到第一个选中位置
      })
    },
		// 全选是否为 定位 或 排除
		allSelect(node, msg) {
			let newCheck = node.allData;
			// 添加选中项 过滤重复选项
			this.checked = [node.resourceName, ...newCheck, ...this.checked].filter((item, index, self) => {
					return self.indexOf(item) == index;
			})
      if(msg == 'position') {
				// 全选 定位 时，把 排除 数组当前父级下已选的 分配转移到 定位 数组中
				let rCheck = newCheck.filter(item => {
					if(this.rightChecked.indexOf(item) == -1) {
						if(!isHave(item, this.sanctionsList)) {
							// 不是制裁国家的，可以分配转移到定位列表
							this.rightChecked.push(item);
						}
					}
					
					return this.excludeChecked.indexOf(item) != -1;
				});
				rCheck.forEach((el) => {
					// 定位全选时，排除的数组选中值剔出  且不是制裁国家
					if(this.excludeChecked.indexOf(el) != -1 && !isHave(el, this.sanctionsList)) {
						
						this.excludeChecked.splice(this.excludeChecked.indexOf(el), 1);
					}
				});
      }else if(msg == 'exclude') {
				// 全选 排除 时，把 定位 数组当前父级下已选的 分配转移到 排除 数组中
				let eCheck = newCheck.filter(item => {
					if(this.excludeChecked.indexOf(item) == -1) {
						this.excludeChecked.push(item);
					}
					
					return this.rightChecked.indexOf(item) != -1;
				});
				eCheck.forEach((el) => {
					// 排除全选时，定位的数组选中值剔出
					if(this.rightChecked.indexOf(el) != -1) {
						
						this.rightChecked.splice(this.rightChecked.indexOf(el), 1);
					}
				});
      }
			this.change();
			this.editName();
		},
		// 远程搜索
		remoteMethod(query) {
			if (query !== '') {
				let arr = [];
				this.searchList = [];
				arr = this.allList.filter(item => {
					return item[this.attrs.label].toLowerCase()
						.indexOf(query.toLowerCase()) > -1;
				});
				arr.forEach(i => {
					this.searchList.push({
						disabled: true,
						...i
					})
				})
			} else {
				this.searchList = [];
			}
		},
		// 批量操作
		batchOperation() {
			this.dialogFormVisible = true;
		},
		// 返回
		goBack() {
			this.dialogFormVisible = true;
			this.dialogTabVisible = false;
		},
		// 开始匹配
		startMatching() {
			this.dialogFormVisible = false;
			this.dialogTabVisible = true;
			let list = [], match = [], unmatch = [];
			let allData = this.allList.map(i => i.name);
			list = this.form.batchValue.split('\n').filter(item => item.trim() != '').map(v=>v.trim());

			list.forEach(val => {
				if(allData.includes(val) && !this.sanctionsListKey.includes(val)) {
					// 正确匹配且不是制裁国家地区
					match.push(val);
				}else {
					// 错误匹配或是制裁国家地区
					unmatch.push(val);
				}
			})


			this.tabs[0].value = match.join('\n');
			this.tabs[0].length = match.length;
			this.tabs[1].value = unmatch.join('\n');
			this.tabs[1].length = unmatch.length;
		},
		// 添加到选中列表
		handleClick() {
			let res = this.tabs[0].value.split('\n').filter(item => item != '').map(v=>v.trim());
			if(this.radio == 1) {
				// 定位
				this.allList.forEach(item => {
					if(res.includes(item.name)) {
						this.position(item, item, 'position');
					}
				})
			}else {
				// 排除
				this.allList.forEach(item => {
					if(res.includes(item.name)) {
						this.exclude(item, item, 'exclude');
					}
				})
			}
			this.dialogTabVisible = false;
			this.tabs.forEach(i => i.value = '');
			this.form.batchValue = '';
		},
		copy() {
			// 复制文本到剪贴板
			let txt = '';
			if(this.activeName == '0') {
				txt = this.tabs[0].value;
				this.$refs.copy[0].select(); // 鼠标选中文本
			}else {
				txt = this.tabs[1].value;
				this.$refs.copy[1].select();
			}
			if(!txt.length) {
				this.$message({
					message: '文本为空',
					type: 'warning',
					customClass: 'zZindex'
				})
				return false;
			}
      navigator.clipboard.writeText(txt)
				.then(() => {
					this.$message({
						message: '文本已成功复制到剪贴板',
						type: 'success',
						customClass: 'zZindex'
					})
				})
				.catch((error) => {
					console.error('复制文本到剪贴板失败:', error);
					this.$message({
						message: '复制文本到剪贴板失败',
						type: 'error',
						customClass: 'zZindex'
					})
				});
		},
		editClassName(className, val) {
			let el = document.querySelector('#skyCascaderPanels .select-card .card').querySelectorAll(className);
			el.forEach(item => {
				item.className = val;
			})
		},
		editName() {
			if(this.timeout) {
				clearTimeout(this.timeout);
			}
			this.timeout = setTimeout(() => {
				this.editClassName('.in-active-path', 'el-cascader-node n-active');
				this.editClassName('.is-active', 'el-cascader-node n-active');
			},0);
		},
	}
};
</script>
<style lang="scss">
.el-select-dropdown.el-popper.is-multiple.searchSelect {
	&>.el-scrollbar {
		&>.el-select-dropdown__wrap.el-scrollbar__wrap {
			&>.el-scrollbar__view.el-select-dropdown__list {
				&>.el-select-dropdown__item {
					cursor: text;
					color: #3DA1FF;
				}
			}
		}
	}
	.searchSelectLeft {
		float: left;
	}
	.searchSelectRight {
		float: right;
	}
	.margin_r_8 {
		margin-right: 8px;
	}
	.disab {
		cursor: no-drop;
    color: #666666;
	}
	.cursor {
		cursor: pointer;
	}
}
.zZindex {
	z-index: 3000 !important;
}
#skyCascaderPanels {
	.search {
		.el-select {
			// display: block;
			width: 30%;
			padding-bottom: 10px;
		}
		.batch {
			color:#3DA1FF;
			padding-left: 10px;
			cursor: pointer;
		}
	}
  &>.select-card {
		min-width: 305px !important;
    display: inline-block;
  }
  .sky_select_card_box {
    display: flex;
		&>.select-card {
			min-width: 295px !important;
		}
  }
  .operation {
    width: 220px;
    display: flex;
    justify-content: space-between;
    cursor: auto;
		font-weight: 400;
		.info {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
    .posi {
      display: block;
			padding-left: 5px;
      .margin_r_8 {
        margin-right: 8px;
      }
      &>span {
        color: #3DA1FF;
        cursor: pointer;
      }
      .disab {
        cursor: no-drop;
        color: #666666;
      }
			.all_select {
				color: #666666;
				cursor: text;
			}
    }
  }
  // .operation:hover .posi {
  //   display: block;
  // }

	.el-cascader-panel {
		border: none;
		.n-active {
			color: #3DA1FF !important;
		}

		.el-cascader-menu__wrap {
			height: 274px;
		}
	}

	.el-scrollbar__wrap {
		height: 274px;
		margin-bottom: 0px !important;
	}
	& .el-scrollbar__view.el-cascader-menu__list 
	.el-checkbox .el-checkbox__input .el-checkbox__inner {
		opacity: .6 !important;
		display: none;
	}
	& .el-scrollbar__view.el-cascader-menu__list 
	.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner,
	& .el-scrollbar__view.el-cascader-menu__list 
	.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: rgba($color: #4f6479, $alpha: .6);
	}
	& .el-scrollbar__view.el-cascader-menu__list li,
	& .el-scrollbar__view.el-cascader-menu__list .el-checkbox,
	& .el-scrollbar__view.el-cascader-menu__list 
	.el-checkbox .el-checkbox__input{
		cursor: text;
	}
	.tabTit {
		display: flex;
		justify-content: space-between;
		.copy {
			cursor: pointer;
			color: #3DA1FF;
		}
	}
}
</style>
